<template>

<core-panel>

	<template v-slot:head>

		<h1>Locations</h1>

		<p>All <b>{{ locations.length }}</b> locations this game has been played at.</p>

	</template>

	<template v-slot:body>

		<app-thing v-for="(item, index) in locations" :nolink="true" :item="item" :key="index" />

	</template>

</core-panel>

</template>

<script>

import Panel from './../../common/Panel'

export default {

	mixins: [Panel],

	data: function() {

		return {
			detail: 'locations',
			locations: []
		}

	},

	methods: {

		response: function(json) {

			this.locations = json.locations

		}

	}

}

</script>

<style scoped>

</style>
